var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmileyRatingPoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 774.69 774.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #e85744;\r\n      }\r\n      .cls-2 {\r\n        fill: #FFFFFF;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 387.34,
    cy: 387.34,
    r: 332.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m259.36,570.68c-2.74,0-5.53-.42-8.28-1.3-14.3-4.57-22.18-19.87-17.61-34.17,21.48-67.17,83.32-112.3,153.88-112.3s132.41,45.13,153.88,112.3c4.57,14.3-3.32,29.59-17.61,34.17-14.3,4.57-29.59-3.32-34.17-17.61-14.24-44.56-55.27-74.49-102.1-74.49s-87.86,29.94-102.1,74.49c-3.69,11.55-14.38,18.91-25.88,18.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m387.34,774.69C173.77,774.69,0,600.92,0,387.34S173.77,0,387.34,0s387.34,173.77,387.34,387.34-173.77,387.34-387.34,387.34Zm0-720.32c-183.61,0-332.98,149.37-332.98,332.98s149.37,332.98,332.98,332.98,332.98-149.37,332.98-332.98S570.95,54.36,387.34,54.36Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 268.2,
    cy: 284.73,
    r: 61.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 506.49,
    cy: 284.73,
    r: 61.28
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileyRatingPoor);
export default __webpack_public_path__ + "static/media/smiley-rating-poor.f71a1c04616a43547d5d82aa3d586406.svg";
export { ForwardRef as ReactComponent };